export const breakpoints = {
  md: '60rem', // 960px
  mdMax: '79.9375rem', // 1279px
  mdLg: '1279.95px',
  lg: '80rem', // 1280px
  tablet: '64rem', // 1024px
  mobile: '31.25rem', // 500px
  tabletSmall: '45rem', // 720px
  tabletMedium: '48rem', // 768px
  desktopWide: '85.375rem'
};
